import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { useFormik } from 'formik'
import { ApplicationState } from '@/state'
import useDialog from '@/hooks/ui/use-dialog.hook'

import { AccountStatusEnum } from '@/enums'
import { getValidationString } from '@/utils'
import { usePlayerCardActions } from './'

export const usePlayerAccountStatusForm = () => {
  const { updateAccountStatus } = usePlayerCardActions()

  const { handleCloseDialog, dialog } = useDialog()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const initialValuesAccountStatus = {
    accountStatus: playerCard?.accountStatus || '',
    accountStatusReason: playerCard?.accountStatusReason || '',
    comment: '',
  }

  const validationSchemaAccountStatus = Yup.object().shape({
    accountStatusReason: Yup.string().when('accountStatus', {
      is: AccountStatusEnum.BLOCKED,
      then: getValidationString({ required: true }),
    }),
    comment: getValidationString({ required: true }),
  })

  const formikAccountStatus = useFormik({
    initialValues: initialValuesAccountStatus,
    validationSchema: validationSchemaAccountStatus,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  const handleSubmit = () => {
    updateAccountStatus({
      playerId: playerCard.id,
      accountStatus: formikAccountStatus.values.accountStatus,
      accountStatusReason: formikAccountStatus.values.accountStatusReason,
      comment: formikAccountStatus.values.comment,
    })
  }

  useEffect(() => {
    formikAccountStatus.resetForm()
  }, [dialog]) // eslint-disable-line

  return {
    dialog,
    formikAccountStatus,
    handleSubmit,
    handleCloseDialog,
  }
}
